// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .serviceCard .cardFlipEffect {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  border-radius: 0 0 1.4rem 1.4rem;
  opacity: 0.4;
  box-shadow: 0 0 0 0.1rem transparent;
}

.serviceCard:hover .cardFlipEffect {
  transform: rotateX(180deg);
  box-shadow: 0 0 0 0.1rem var(--accent-color3);
} */`, "",{"version":3,"sources":["webpack://./src/pages/public/Home/SobreNos/styles.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;GAeG","sourcesContent":["/* .serviceCard .cardFlipEffect {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transform-style: preserve-3d;\n  top: 0;\n  left: 0;\n  border-radius: 0 0 1.4rem 1.4rem;\n  opacity: 0.4;\n  box-shadow: 0 0 0 0.1rem transparent;\n}\n\n.serviceCard:hover .cardFlipEffect {\n  transform: rotateX(180deg);\n  box-shadow: 0 0 0 0.1rem var(--accent-color3);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
